<template>
  <div>
    <div class="contents badgelist">
      <table class="table board toggle-xl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.admin.grade") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.common.image") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="totalCnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xl-table-cell w-1">{{ item.no }}</td>
              <td class="col-auto text-start">
                <a class="d-inline-block more text-break">{{ item.title }}</a>
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ item.grade }}
              </td>
              <td class="col-auto d-none d-md-table-cell">
                <img
                  :src="item.filename | get_img"
                  class="avatar avatar-lg"
                />&nbsp;
                <img :src="item.filename2 | get_img" class="avatar avatar-lg" />
              </td>
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>

              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-secondary btn-xs mx-auto"
                  @click="
                    $router.push({
                      name: 'BadgeEdit',
                      params: { badge_pk: item.badge_pk },
                    })
                  "
                >
                  {{ $t("button.common.edit") }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-xs text-white mx-auto"
                  @click="delete_badge(item.badge_pk)"
                >
                  {{ $t("button.common.delete") }}
                </button>
              </td>

              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.admin.grade") }}</div>
                    <div class="col-8">{{ item.grade }}</div>
                  </div>

                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.image") }}</div>
                    <div class="col-8">
                      <img
                        :src="item.filename | get_img"
                        class="avatar avatar-lg"
                      />&nbsp;
                      <img
                        :src="item.filename2 | get_img"
                        class="avatar avatar-lg"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'BadgeWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "BAdgeList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$store.state.searchData.startdate ||
          1,
        enddate:
          this.$route.query.enddate ||
          this.$store.state.searchData.enddate ||
          1,
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },

    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_badgelist(this.searchData, (flag, data) => {
        this.totalCnt = data.listcnt;
        this.pageTotal = Math.ceil(data.listcnt / this.rows);
        this.items = data.list;
        if (!flag) alert(data.message);
      });
    },
    delete_badge(badge_pk) {
      if (confirm(this.$i18n.t("alert.common.want_to_delete"))) {
        ax.delete_badge(badge_pk, (flag, data) => {
          if (flag) {
            alert(data.message);
            this.getList();
          } else {
            alert(data.message);
          }
        });
      }
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
